import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Loader from './components/Loader';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Projects from './pages/Projects';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import Fonts from './pages/Fonts';
import OurWork from './pages/OurWork';
import CSR from './pages/CSR';
import Subcontractors from './pages/Subcontractors';
import Feedback from './pages/Feedback';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
}

function RevealObserver() {
  useEffect(() => {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.12 });
    const apply = () => document.querySelectorAll('.reveal, .mask-reveal, .zoom-in').forEach((el) => io.observe(el));
    apply();
    const mo = new MutationObserver(apply);
    mo.observe(document.body, { childList: true, subtree: true });
    return () => { io.disconnect(); mo.disconnect(); };
  }, []);
  return null;
}

function App() {
  const [loading, setLoading] = useState(() => !sessionStorage.getItem('tes_loaded'));
  useEffect(() => { if (!loading) sessionStorage.setItem('tes_loaded', '1'); }, [loading]);
  return (
    <BrowserRouter>
      {loading && <Loader onDone={() => setLoading(false)} />}
      <ScrollToTop />
      <RevealObserver />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/our-work" element={<OurWork />} />
        <Route path="/csr" element={<CSR />} />
        <Route path="/subcontractors" element={<Subcontractors />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/csat" element={<Feedback />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/fonts" element={<Fonts />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
